import React from 'react'

import Text from 'components/common/Text'

import { Container, Item } from './styles'

const Dropdown = props => {
    const { menus = [] } = props

    return (
        <Container className="dropdown">
            {menus.map((menu, key) => {
                return (
                    <Item.Area key={key} onClick={menu.onClick}>
                        <Item.Icon>
                            <img src={menu.icon} alt={menu.alt} />
                        </Item.Icon>
                        <Item.Copy>
                            <Text level="3" bold={false}>
                                {menu.copy}
                            </Text>
                        </Item.Copy>
                    </Item.Area>
                )
            })}
            {props.children}
        </Container>
    )
}

export { Dropdown }
